import { Box } from "@mui/material";
import LiveGamesComponent from "../../components/live-games/live-games";
function LiveGamesPage() {
  return <Box>{<LiveGamesComponent />}</Box>;
}

export default LiveGamesPage;
